import { useEffect, useState } from "react";
import { OrganizationDetails } from "../utils/types";
import { fetchUsers } from "../services/useService";

export const useBusinessInfo = () => {
  const [filteredData, setFilteredData] = useState<OrganizationDetails[]>([]);
  const [businessPrint, setBusinessPrint] = useState({ logo: "", phone: "", name: "", addressline: "", arabicName: "",});
  const businessArabicName = filteredData.find((item): item is OrganizationDetails => (item as OrganizationDetails).org_arabic_name !== undefined)?.org_arabic_name || "";
  const businessAddreeline = filteredData.find((item): item is OrganizationDetails => (item as OrganizationDetails).address_line_1 !== undefined)?.address_line_1 || "";
  const logoUrl = sessionStorage.getItem(`Logo${sessionStorage.getItem("organization_name")}`) || "";

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const res = await fetchUsers();
        setFilteredData(res.data.result);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    loadUsers();
  }, []);

  useEffect(() => {
    const businessTypeString = sessionStorage.getItem("business_type");
    let businessData = { logo: "", phone: "", name: "", addressline: "", arabicName: "",};

    if (businessTypeString) {
      try {
        businessData = JSON.parse(businessTypeString);
      } catch {
        businessData.name = businessTypeString;
      }
    }

    const bussinessname = sessionStorage.getItem("organization_name") || "";
    const businessArabicName = sessionStorage.getItem("businessArabicName") || "";
    const businessAddress = sessionStorage.getItem("address") || "";
    const businessPhone = sessionStorage.getItem("business_phone") || "";
    const businessLogo = sessionStorage.getItem(`Logo${bussinessname}`) || "";

    setBusinessPrint({
      logo: businessLogo,
      phone: businessPhone || businessData.phone,
      name: bussinessname,
      addressline: businessAddress || businessData.addressline,
      arabicName: businessArabicName,
    });
  }, []);

  return { businessPrint, businessArabicName, businessAddreeline, logoUrl };
};
